<template>
    <el-row type="flex" justify="center" id="loginForm" style="height: inherit">
        <el-col :xs="24" :sm="15" :md="10" :lg="5" :xl="5" >
            <el-card style="min-height: 350px; margin-top: 50px;">
                <template #header>
                    <div style="text-align: center; font-size: 1.3rem;">
                        {{appName}}
                    </div>
                </template>
                <el-form ref="form" :model="login" :rules="rules">
                    <el-form-item prop="userId">
                        <el-input
                                v-model="login.userId"
                                placeholder="請輸入帳號(學號或員工編號)"
                                id="userId"
                                prefix-icon="el-icon-user"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="password" type="password">
                        <el-input
                                v-model="login.password"
                                placeholder="請輸入密碼"
                                :show-password="true"
                                prefix-icon="el-icon-lock"
                        >

                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="login.remember">記住我</el-checkbox>
                    </el-form-item>
                    <el-button @click="submit" type="primary" style="width: 100%;">
                        登入
                    </el-button>
                </el-form>
                <el-divider>注意事項</el-divider>
                <small v-html="(viewContent || {}).loginPage"></small>
            </el-card>

        </el-col>

    </el-row>
</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex';
    import appNameMixin from '../appNameMixin';
    export default {
        name: 'Login',
        mixins:[appNameMixin],
        data: () => ({
            login: {
                userId: '',
                password: '',
                remember: true
            },
            rules: {
                userId: [
                    {required: true, message: '請輸入帳號', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '請輸入密碼', trigger: 'blur'}
                ]
            }
        }),
        computed: {
            ...mapState({
                showFailureMessage: state => state.auth.showFailureMessage,
                loading: 'loading'
            }),
            ...mapGetters({
                authenticated: 'auth/authenticated'
            }),
            ...mapState('setting', ['viewContent']),
        },
        methods: {
            ...mapActions('setting', {
                getViewContent: 'getViewContentAction'
            }),
            async submit() {
                const form = this.$refs.form;
                form.validate(async (valid) => {
                    if (valid) {
                        if (await this.authenticate(this.login)) {
                            const {redirect} = this.$route.query;
                            form.resetFields();
                            this.$router.replace(redirect ? {name: redirect} : '/');
                        } else {
                            this.$message({
                                message: '帳號或密碼錯誤，請重新輸入',
                                type: 'warning'
                            });
                            form.resetFields();
                        }
                    }
                });
            },
            ...mapActions({
                authenticate: 'auth/authenticate'
            }),

            async onEnter(e){
                if(e.key === 'Enter'){
                    e.preventDefault();
                    e.stopPropagation();
                    await this.submit();
                }
            }
        },
        async created() {
            await this.getViewContent();
            document.addEventListener('keyup', this.onEnter);
        },
        destroyed() {
            document.removeEventListener('keyup', this.onEnter);
        }
    }
</script>

<style>

</style>